/* app/js/src/components/common/close-btn/animated-x-btn/animated-x-btn.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  width: 15px;
  height: 15px;
  padding: 2px;
}
div svg path {
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div:hover svg path {
  -ms-transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
/*# sourceMappingURL=animated-x-btn.component.css.map */
